export const SB = 'SB'
export const BB = 'BB'
export const UTG = 'UTG'
export const UTG1 = 'UTG1'
export const MP = 'MP'
export const MP1 = 'MP1'
export const HIJ = 'HIJ'
export const CO = 'CO'
export const BTN = 'BTN'
export const POSITIONS = [BTN, SB, BB, UTG, UTG1, MP, MP1, HIJ, CO]
export const POSITIONS_ON_PREFLOP = [UTG, UTG1, MP, MP1, HIJ, CO, BTN, SB, BB]

export const HERO = 'Hero'
export const VILLAIN = 'Villain'

export const PREFLOP = 'preflop'
export const FLOP = 'flop'
export const TURN = 'turn'
export const RIVER = 'river'
export const STREETS = [PREFLOP, FLOP, TURN, RIVER]

export const FOLD = 'fold'
export const CALL = 'call'
export const CHECK = 'check'
export const ALLIN = 'allin'
export const RAISE = 'raise'
export const BET = 'bet'
export const ACTIONS = [FOLD, CALL, RAISE, ALLIN]

export const STATUS = {
	WAIT: 'wait',
	STOP: 'stop',
	SUCCESS: 'success',
}

export const PREFLOP_ACTIONS = ['RFI', 'vs Open', 'vs 3-Bet', 'vs 4-Bet', 'vs Limp', 'vs ISO']
export const POSTFLOP_ACTIONS = ['SRP', '3-Bet', '4-Bet', 'LP', 'ISO']

export const SUITS = ['c', 's', 'd', 'h']
export const RANKS = ['A', 'K', 'Q', 'J', 'T', '9', '8', '7', '6', '5', '4', '3', '2']
